import { Container, DefaultPageLayout } from 'routes/components/Layout'
import { LINKS } from 'routes/constants'
import { BreadcrumbsNavigation } from 'routes/components/Shared'
import { BestSupport } from 'routes/components/Features/BestSupport'
import {
  ConnectorsStatsType,
  getSolutionsBreadcrumbs,
  PageType,
} from 'routes/Solutions/helpers'
import { SolutionHeadMetatag } from 'routes/Solutions/components/SolutionHeadMetatag'
import { SolutionSection } from 'routes/Solutions/components/SolutionSection'
import { SolutionNetwork } from 'routes/Solutions/components/SolutionNetwork'
import { SolutionRequest } from 'routes/Solutions/components/SolutionRequest'
import { SolutionAI } from 'routes/Solutions/components/SolutionAI'
import { SolutionCompanies } from 'routes/Solutions/components/SolutionCompanies'
import { SolutionInfrastructure } from 'routes/Solutions/components/SolutionInfrastructure'
import { WorkflowAutomationToolsHero } from './components/Hero'
import { WorkflowAutomationToolsFramework } from './components/Framework'
import { WorkflowAutomationToolsInfrastructure } from './components/Infrastructure'
import pageCoverImage from './components/Infrastructure/image-desk.svg'
import classes from '../solutions.module.scss'

export const pageData: PageType = {
  title: 'Workflow Automation Tools',
  href: LINKS.SOLUTIONS.WORKFLOW_AUTOMATION_TOOLS,
  imageSrc: `${pageCoverImage.src}`,
  description:
    'Supercharge your app by adding all the connectors your customers need.',
  large: true,
}

export default function WorkflowAutomationToolsPage({
  stats,
}: {
  stats: ConnectorsStatsType
}) {
  const breadcrumbs = getSolutionsBreadcrumbs(pageData.title)

  return (
    <DefaultPageLayout className={classes.page}>
      <SolutionHeadMetatag pageData={pageData} />
      <Container>
        <BreadcrumbsNavigation
          breadcrumbs={breadcrumbs}
          className={classes.breadcrumbs}
        />
      </Container>
      <Container grid>
        <WorkflowAutomationToolsHero />
        <SolutionSection>
          <SolutionNetwork stats={stats} showAllStats />
          <WorkflowAutomationToolsFramework />
          <WorkflowAutomationToolsInfrastructure />
        </SolutionSection>
        <SolutionRequest />
        <SolutionAI
          title='Scale your connector library with Al'
          text='Building connectors is slow and tedious, but LLMs are really good at mapping API specifications and documentation to a pre-defined framework. Leverage our Al-powered tooling to accelerate your connectors roadmap 10x.'
        />
        <SolutionCompanies
          title='Battle-tested by leading Workflow Automation products'
          subtitle='World-class data integration platforms build their connectivity on top of Integration App'
        />
        <SolutionInfrastructure />
        <BestSupport
          isSolutionsSection
          subtitle={
            <>
              Integrations are hard and messy. <br /> Our success team will help
              you every step of the way.
            </>
          }
          className={classes.support}
        />
      </Container>
    </DefaultPageLayout>
  )
}
